import {
  Select as IkeaDropdown,
  Option as IkeaDropdownItem
} from '@ingka/select';
import CONFIG from 'Config/settings';
import PropTypes from 'prop-types';
import React from 'react';

class CountryCodeDropdown extends React.PureComponent {
  render() {
    const { options, topOptions, value } = this.props;

    const isCountryFixed = options.length === 1;
    const selectedOption = options.find(option => option.value === value);

    return (
      <IkeaDropdown
        prefix={CONFIG.APP.STYLES_PREFIX}
        value={value}
        onChange={e => {
          const selected = options.find(
            option => option.value === e.target.value
          );
          if (selected) {
            this.props.onChange(selected);
          }
        }}
        disabled={isCountryFixed}
        aria-label={
          selectedOption
            ? `${selectedOption.name} (${selectedOption.code})`
            : ''
        }
        id={`country-code-dropdown-list-${this.props.componentName}`}
      >
        {topOptions.map(option => (
          <IkeaDropdownItem
            key={`option-${option.name}`}
            id={`country-code-dropdown-${this.props.componentName}-${option.name}`}
            value={option.value}
            name={
              CONFIG.FEATURE.RIGHT_TO_LEFT
                ? `(${option.code.replace(/(\+)(.*)/, '$2$1')}) ${option.name}`
                : `${`${option.name} (${option.code})`}`
            }
          />
        ))}
        {topOptions.length > 0 && <option disabled>──────────</option>}
        {(this.props.sortOptions
          ? options.sort((o1, o2) => o1.name.localeCompare(o2.name))
          : options
        ).map(option => (
          <IkeaDropdownItem
            key={`option-${option.name}`}
            value={option.value}
            name={
              CONFIG.FEATURE.RIGHT_TO_LEFT
                ? `(${option.code.replace(/(\+)(.*)/, '$2$1')}) ${option.name}`
                : `${`${option.name} (${option.code})`}`
            }
          />
        ))}
      </IkeaDropdown>
    );
  }
}

CountryCodeDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired
    })
  ).isRequired,
  topOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired
    })
  ),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  sortOptions: PropTypes.bool,
  formId: PropTypes.string,
  componentName: PropTypes.string
};

export default CountryCodeDropdown;
